var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16.5,
    r: 16,
    fill: "#EBEEF2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m19.982 8.503-2.07-.003c-2.324 0-3.826 1.546-3.826 3.938v1.815h-2.08a.326.326 0 0 0-.326.326v2.631c0 .18.145.326.325.326h2.08v6.638c0 .18.146.326.326.326h2.715c.18 0 .325-.146.325-.326v-6.638h2.433c.18 0 .325-.146.325-.326l.001-2.63a.327.327 0 0 0-.325-.327H17.45v-1.539c0-.74.176-1.115 1.137-1.115h1.394c.18 0 .325-.147.325-.327V8.83a.326.326 0 0 0-.325-.327Z",
    fill: "#414E5F"
  })));
};
export default SvgFacebook;